import Model from './base/model';

class Product extends Model {
  resourceName() {
    return 'products';
  }

  fields() {
    return {
      code: '',
      description: '',
      shipper: '',
      manufacturer_code: '',
      manufacturer: '',
      platform: '',
      group: '',
      is_dangerous: '',
      location: '',
      length: '',
      width: '',
      height: '',
      dimension_unit: '',
      volume: '',
      volume_unit: '',
      weight: '',
      weight_net: '',
      weight_unit: '',
      default_price: '',
      is_temp_controlled: '',
      min_temp: '',
      max_temp: '',
      goes_in_box: '',
      quantity: '',
      sap_line_number: '',
      batch_number: '',
      shipper: { jsonApi: "hasOne", type: "shippers"},
      files: { jsonApi: 'hasMany', type: 'request'},
      expected_date: '',
    };
  }
}

export default new Product();
